import { mutator } from 'satcheljs';
import PolicyFetchRequestStatus from '../store/schema/PolicyFetchRequestStatus';
import {
    onAvailablePoliciesRequestSent,
    onAvailablePoliciesRequestComplete,
    onAvailablePoliciesRequestError,
} from '../actions/internalActions';
import getAvailablePoliciesListState from '../selectors/getAvailablePoliciesListState';

mutator(onAvailablePoliciesRequestSent, () => {
    getAvailablePoliciesListState().fetchRequestStatus = PolicyFetchRequestStatus.Pending;
});

mutator(onAvailablePoliciesRequestComplete, () => {
    getAvailablePoliciesListState().fetchRequestStatus = PolicyFetchRequestStatus.Complete;
});

mutator(onAvailablePoliciesRequestError, () => {
    getAvailablePoliciesListState().fetchRequestStatus = PolicyFetchRequestStatus.Error;
});
